/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    object, node,
} from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import BrandTheme from './BrandTheme/BrandTheme';
import { getBrand } from '../state/Selectors';

const AppShell = ({ children, brand }) => (
    <BrandTheme brand={brand}>
        { children }
    </BrandTheme>
);

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

AppShell.propTypes = {
    children: node.isRequired,
    brand: object.isRequired,
};

export default compose(
    connect(mapStateToProps),
)(AppShell);
